<template>
  <div class="flex-direction">
    <div class="table-container-v3">
      <table class="table table-v3 is-fullwidth is-striped">
        <thead>
          <tr>
            <th class="has-text-centered">Folio</th>
            <th>Asunto</th>
            <th class="has-text-centered">Módulo</th>
            <th class="has-text-centered">Prioridad</th>
            <th class="has-text-centered">Estatus</th>
            <th class="has-text-centered">Fecha</th>
            <th class="has-text-centered">Acciones</th>
          </tr>
        </thead>

        <tbody v-if="!isLoading && tickets.length">
          <tr v-for="ticket in tickets" :key="ticket.id" class="ticket-row">
            <td class="has-text-centered">
              <span class="ticket-row__folio">{{ ticket.folio }}</span>
            </td>
            <td>
              <span class="ticket-row__subject">{{ ticket.subject }}</span>
            </td>
            <td class="has-text-centered">
              <span class="-gray">{{ ticket.moduleName }}</span>
            </td>
            <td class="has-text-centered">
              <span class="tag ticket-tag" :class="priorityClass(ticket.priorityCode)">
                {{ ticket.priorityName }}
              </span>
            </td>
            <td class="has-text-centered">
              <span class="tag ticket-tag" :class="statusClass(ticket.statusCode)">
                {{ ticket.statusName }}
              </span>
            </td>
            <td class="has-text-centered">
              <span class="inactive-label -gray ticket-row__date">
                {{ formatDate(ticket.createdAt, 'DD-MMMM-YYYY', systemConfiguration.lang) }}
              </span>
            </td>
            <td class="has-text-centered">
              <div class="dropdown">
                <a
                  id="panelNavBurger"
                  role="button"
                  data-target="panelNavMenu"
                  aria-expanded="false"
                  aria-label="menu"
                  class="dropbtn"
                >
                  <i class="fas fa-ellipsis-v" />
                </a>
                <div class="dropdown-content">
                  <a class="navbar-item" @click="goToDetail(ticket)">
                    Ver detalle
                  </a>
                  <a class="navbar-item" v-if="ticket.statusCode !== 'cerrado'" @click="askCloseTicket(ticket)">
                    Cerrar Ticket
                  </a>
                </div>
              </div>
            </td>
          </tr>
        </tbody>

        <tbody v-else-if="isLoading">
          <tr v-for="n in 8" :key="n">
            <td><div class="-loading-text -w30"></div></td>
            <td><div class="-loading-text -w80"></div></td>
            <td><div class="-loading-text -w60"></div></td>
            <td><div class="-loading-text -w30"></div></td>
            <td><div class="-loading-text -w30"></div></td>
            <td><div class="-loading-text -w60"></div></td>
            <td><div class="-loading-text -w30"></div></td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr>
            <td colspan="7" class="has-text-centered -text3 -gray">
              Sin información
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="column is-12 has-text-centered">
      <Paginator :page="pagination.pageNumber" :pages="pagination.totalPages" :loading="isLoading" :action="getTickets" />
    </div>

    <ModalComponent
      :active="isConfirmCloseModalOpen"
      titleModal="Cerrar ticket"
      optionalText="¿Estás seguro de que quieres cerrar este ticket?"
      :isConfirm="true"
      textSave="Cerrar Ticket"
      :loader="isClosingTicket"
      @accept="confirmCloseTicket"
      @cancel="cancelCloseTicket"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import mixins from '@/mixins/formats'

export default {
  name: 'TicketsList',
  mixins: [mixins],
  components: {
    Paginator: () => import('@/components/ui/BasePagination.vue'),
    ModalComponent: () => import('@/components/ui/ModalComponent.vue')
  },
  props: {
    tickets: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => ({ pageNumber: 1, totalPages: 1 })
    },
    getTickets: {
      type: Function
    },
    isLoading: {
      type: Boolean
    }
  },
  data () {
    return {
      isConfirmCloseModalOpen: false,
      isClosingTicket: false,
      ticketToClose: null
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration
    })
  },
  methods: {
    ...mapActions(['closeTicket']),
    goToDetail (ticket) {
      this.$router.push({ name: 'profile-ticket-detail', params: { id: ticket.id } })
    },
    askCloseTicket (ticket) {
      this.ticketToClose = ticket
      this.isConfirmCloseModalOpen = true
    },
    cancelCloseTicket () {
      this.isConfirmCloseModalOpen = false
      this.ticketToClose = null
    },
    async confirmCloseTicket () {
      if (!this.ticketToClose) return
      this.isClosingTicket = true
      const updatedTicket = await this.closeTicket({ ticketId: this.ticketToClose.id })
      this.isClosingTicket = false
      if (updatedTicket) {
        this.$emit('ticket-closed', updatedTicket)
        this.isConfirmCloseModalOpen = false
        this.ticketToClose = null
      }
    },
    priorityClass (code) {
      const map = {
        baja: 'is-light',
        media: 'is-info is-light',
        alta: 'is-warning is-light',
        urgente: 'is-danger is-light'
      }
      return map[code] || 'is-light'
    },
    statusClass (code) {
      const map = {
        nuevo: 'is-info is-light',
        en_proceso: 'is-warning is-light',
        on_hold: 'is-light',
        escalado: 'is-danger is-light',
        dependencia_cliente: 'is-warning is-light',
        validacion_cliente: 'is-info is-light',
        resuelto: 'is-success is-light',
        cerrado: 'is-light'
      }
      return map[code] || 'is-light'
    }
  }
}
</script>

<style lang="scss" scoped>
.dropbtn {
  padding: 0 10px;
}

.ticket-row {
  transition: background-color 0.15s ease;

  td {
    padding: 1rem 0.85rem !important;
  }
}

.ticket-row__folio {
  color: #7c7d7e;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  letter-spacing: 0.02em;
}

.ticket-row__subject {
  color: #1a2233;
  font-weight: 500;
}

.ticket-row__date {
  align-items: center;
  display: inline-flex;
  gap: 4px;
}

.ticket-tag {
  align-items: center;
  display: inline-flex;
  font-weight: 500;
  gap: 5px;
  min-width: 96px;
}

// Mejor contraste que el default de Bulma para los estados "light"
.tag.is-light {
  background-color: #eceef2;
  color: #5f7081;
}

.tag.is-info.is-light {
  background-color: #e3f2ff;
  color: #0074cc;
}

.tag.is-warning.is-light {
  background-color: #fff4e0;
  color: #b26a00;
}

.tag.is-danger.is-light {
  background-color: #ffe8e8;
  color: #d32f2f;
}

.tag.is-success.is-light {
  background-color: #e3f8ee;
  color: #1f9d63;
}
</style>
